import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

function QRGun(props) {
    return (
        <SvgIcon viewBox="0 0 48 48" {...props}>
            <g id="QRGun">
                <path stroke="currentColor" d="M32.82,40.08H31.16V38.66h1.66a3.5,3.5,0,0,0,3.5-3.5V30.48h1.42v4.68a4.92,4.92,0,0,1-4.92,4.92Zm0,0" />
                <rect stroke="currentColor" x="28.38" y="11.41" width="11.53" height="1.42" />
                <rect stroke="currentColor" x="6.67" y="7.86" width="1.42" height="1.42" />
                <rect stroke="currentColor" x="3.84" y="7.86" width="1.42" height="1.42" />
                <rect stroke="currentColor" x="1" y="7.86" width="1.42" height="1.42" />
                <rect stroke="currentColor" x="9.51" y="7.86" width="1.42" height="1.42" />
                <rect stroke="currentColor" x="9.51" y="12.12" width="1.42" height="1.42" />
                <rect stroke="currentColor" x="3.84" y="12.12" width="1.42" height="1.42" />
                <rect stroke="currentColor" x="1" y="12.12" width="1.42" height="1.42" />
                <rect stroke="currentColor" x="12.35" y="12.12" width="1.42" height="1.42" />
                <rect stroke="currentColor" x="6.67" y="12.12" width="1.42" height="1.42" />
                <rect stroke="currentColor" x="9.51" y="16.37" width="1.42" height="1.42" />
                <rect stroke="currentColor" x="1" y="16.37" width="1.42" height="1.42" />
                <rect stroke="currentColor" x="6.67" y="16.37" width="1.42" height="1.42" />
                <rect stroke="currentColor" x="3.84" y="16.37" width="1.42" height="1.42" />
                <path stroke="currentColor" d="M39.91,5H14.85l4.32,14.72h6.56V24a4.26,4.26,0,0,0,3.54,4.2v5.56a3.55,3.55,0,0,1-3.54,3.54H25V43h7.8a7.8,7.8,0,0,0,7.8-7.8v-16A7.09,7.09,0,0,0,39.91,5ZM20.23,18.32,16.75,6.44h1.36l3.48,11.88Zm.19-9H39.91a2.84,2.84,0,1,1,0,5.67H22.08ZM27.15,24V19.74h2.12v7A2.83,2.83,0,0,1,27.15,24Zm12.76-6.2H39.2V35.16a6.39,6.39,0,0,1-6.38,6.39H26.44V38.66a5,5,0,0,0,4.25-4.91V18.32H23.07l-.57-1.95H39.91a4.26,4.26,0,1,0,0-8.51H20l-.42-1.41H39.91a5.67,5.67,0,1,1,0,11.34Zm0,0" />
            </g>
        </SvgIcon>
    );
}

export default QRGun;